import { render, staticRenderFns } from "./header-menu.vue?vue&type=template&id=b0d41d7e"
import script from "./header-menu.vue?vue&type=script&lang=js"
export * from "./header-menu.vue?vue&type=script&lang=js"
import style0 from "./header-menu.vue?vue&type=style&index=0&id=b0d41d7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports